import {Item} from '@hconnect/common/Invite/Create/components/LookupDropdown'
import {ErrorPaper, SelectDropdown} from '@hconnect/uikit'
import {Box} from '@mui/material'
import React from 'react'
import {Controller} from 'react-hook-form'

import {BrandingForCountry} from '../../../components/UserInformation/utils/utils'
import {useTranslation} from '../../../hooks/useTranslation'
import {useWidgetUserCreationStyles} from '../WidgetUserCreation.styles'

import {WidgetInputsProps} from './WidgetInputs.types'

type WidgetBrandingInputProps = WidgetInputsProps & {
  brandings: BrandingForCountry[]
  isLoadingBrandings: boolean
}
export const WidgetBrandingInput = ({
  formMethods,
  brandings,
  isLoadingBrandings
}: WidgetBrandingInputProps) => {
  const {t} = useTranslation()
  const {classes} = useWidgetUserCreationStyles()

  const preselectedBranding = brandings.length === 1 ? brandings[0] : undefined

  return (
    <Controller
      name="branding"
      control={formMethods.control}
      render={({field}) => (
        <SelectDropdown
          {...field}
          showSearch={false}
          disabled={!formMethods.watch().country}
          data-test-id="widget-branding-dropdown"
          label={t('widgetUserCreation.form.branding')}
          className={classes.selectDropdown}
          errorRender={() => <ErrorPaper variant="primaryDark" />}
          selectedProps={{style: {fontWeight: 400}}}
          showError={false}
          loading={isLoadingBrandings}
          options={brandings.map((branding) => ({
            value: branding.brandingId,
            label: branding.brandingName
          }))}
          renderItem={(item: Item) => (
            <Box style={{display: 'flex', flexDirection: 'column'}}>
              <Box>{item.label}</Box>
              <Box>{item.value}</Box>
            </Box>
          )}
          stringifyItem={(item: Item) => item.value}
          renderChosenItem={(item: Item) => item.label}
          selectedItem={{
            label:
              brandings?.find((option) => option.brandingId === field.value)?.brandingName ||
              preselectedBranding?.brandingName ||
              '',
            value:
              brandings?.find((option) => option.brandingId === field.value)?.brandingId ||
              preselectedBranding?.brandingId ||
              ' '
          }}
          popoverStyle={{left: 0}}
          onChange={(item) => {
            field.onChange(item.value)
          }}
        />
      )}
    />
  )
}
